import BaseApi from './BaseApi';

/**
 * LINE問い合わせフラグ取得API。
 */
class GetKaiinMessagingInfoApi extends BaseApi {
  async get(companyId: string) {
    return await this.execute('getKaiinMessagingInfoApi', {
      method: 'POST',
      body: { companyIdList: [companyId] }
    }).then(
      ({ result }) => result?.[0]?.displayLineInquiryButtonFLG as boolean
    );
  }
}

export default GetKaiinMessagingInfoApi;
